// extracted by mini-css-extract-plugin
export var animationContainer = "_on-0";
export var footer = "_on-1";
export var gray = "_on-2";
export var lineItem = "_on-3";
export var lineItemImage = "_on-4";
export var lineItemInfo = "_on-5";
export var lineItemText = "_on-6";
export var lineItems = "_on-7";
export var modalContent = "_on-8";
export var options = "_on-9";
export var orderName = "_on-a";
export var refundAmount = "_on-b";